import { IApplicationState } from '../../types/redux';
import { getDeveloper } from '../developerV2';

export function getDeveloperId(state: IApplicationState) {
  const developer = getDeveloper(state);

  return developer.id;
}
